export enum FeeSubmissionCollectionType {
  PHONE = 'PHONE',
  ONLINE = 'ONLINE',
  IN_PERSON = 'IN_PERSON',
}
